import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush, ComposedChart , Line} from 'recharts';
import { React, useEffect, useState } from 'react';
import TokenService from '../../../services/TokenService';
import { useSnackbar } from 'notistack';
import DatePickerDropdown from '../../DatePickerDropdown.jsx'
import dayjs from 'dayjs';

export default function MarketingPanel(props) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [marketingChartData, setMarketingChartData] = useState(null);
    const [selectedDailyRangeStart, setSelectedDailyRangeStart] = useState(dayjs().add(-30, 'day').format('MM/DD/YYYY'));
    const [selectedDailyRangeEnd, setSelectedDailyRangeEnd] = useState(dayjs().format('MM/DD/YYYY'));
 
    useEffect(() => {
        loadAccount(); // only called once
    }, [selectedDailyRangeEnd]);

    //useEffect(() => {
    //    loadAccount(); // only called once
    //}, []);

    function loadAccount() {

       // adminServicePost(postData, method, loadingMessage)
        let postData = {
            startRange: selectedDailyRangeStart,
            endRange: selectedDailyRangeEnd
        }

        TokenService.adminServicePost(postData, 'MarketingStreams')
            .then((response) => {
                //response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    if (response.JsonData != '') {
                        let data = JSON.parse(response.JsonData);
                        if (data != null) {
                            if (data.length > 0) {
                                let referrers = [];

                                for (let i = 0; i < data.length; i++) {
                                    if (referrers[data[i].Referrer] == undefined) {
                                        referrers[data[i].Referrer] = {
                                            DidEnterZipCount: data[i].DidEnterZip,
                                            DidCreatePickupCount: data[i].DidCreatePickup,
                                            Profit: data[i].Profit == null ? 0 : data[i].Profit,
                                            RepeatCustomerCount: data[i].RepeatCustomer,
                                            HitCount: 1
                                        };
                                    }
                                    else {
                                        referrers[data[i].Referrer].DidEnterZipCount += data[i].DidEnterZip;
                                        referrers[data[i].Referrer].DidCreatePickupCount += data[i].DidCreatePickup;
                                        referrers[data[i].Referrer].RepeatCustomerCount += data[i].RepeatCustomer;
                                        referrers[data[i].Referrer].Profit += data[i].Profit;
                                        referrers[data[i].Referrer].HitCount++;
                                    }

                                }

                                // format it for the chart
                                let marketingData = [];
                                for (var key in referrers) {
                                    if (referrers.hasOwnProperty(key)) {
                                        marketingData.push({
                                            name: key,
                                            'Entered Zip': referrers[key].DidEnterZipCount,
                                            'Created Pickup': referrers[key].DidCreatePickupCount,
                                            'No Action': referrers[key].HitCount - referrers[key].DidEnterZipCount,
                                            Profit: referrers[key].Profit.toFixed(2),
                                            'Repeat Customer': referrers[key].RepeatCustomerCount,
                                            'New Customer': referrers[key].DidCreatePickupCount - referrers[key].RepeatCustomerCount,
                                            HitCount: referrers[key].HitCount,
                                        })
                                    }
                                }

                                // sort by most hitCounts
                                marketingData.sort((a, b) => (a.HitCount > b.HitCount) ? -1 : 1);

                                setMarketingChartData(marketingData);
                            }
                            else {
                                setMarketingChartData([]);
                            }
                        }
                    }
                    

                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            }); 

    }

    function handleDateSelected(start, end) {
        if (start != undefined) {
            
            setSelectedDailyRangeStart(start.format('MM/DD/YYYY'));
            setSelectedDailyRangeEnd(end.format('MM/DD/YYYY'));
            

        }
    }

    return (
        <div componentname='MarketingPanel' style={{ minHeight: '500px', height: '500px' }}>
            <div style={{display:'flex', paddingLeft:'15px'} }>
                <DatePickerDropdown tooltipText='Change date range' onDateSelected={(start, end) => handleDateSelected(start, end)} />
                <div style={{alignSelf:'center', marginLeft:'10px'} }>
                    {selectedDailyRangeStart} to {selectedDailyRangeEnd}
                </div>
            </div>
            {marketingChartData == null ? null :
                <ResponsiveContainer width="100%" height="100%" >
                    <ComposedChart
                        width={500}
                        height={300}
                        data={marketingChartData}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                       {/* <Legend />*/}
                     
                        
                        <Bar dataKey='Repeat Customer' stackId={'a'} fill="#299000" />
                        <Bar dataKey='New Customer' stackId={'a'} fill="#98c800" />
                        <Bar dataKey='Entered Zip' stackId={'a'} fill="#277bc0" />
                        <Bar dataKey='No Action' stackId={'a'} fill="#a4a4a4" />
                        <Line type="monotone" strokeWidth='2' dataKey="Profit" stroke="#9700c8" />
                        
                    </ComposedChart>
                </ResponsiveContainer>
                }
              
           
        </div>
    )
}